import { MaintenanceModeNotificationViewModel } from 'src/proxy/api/walkandpunch-api.proxy';
import { Component, OnInit } from '@angular/core';
import { Subscription, take, finalize } from 'rxjs';
import { LoaderService } from '../shared/loader/service/loader.service';
import { defaultfilterFullDatetimeFormatGMT, parseDateByConfiguredLocal } from '../shared/utils/date.utils';
import { SignalRChannel } from '../wap/configuration/shared/models/signlaR.model';
import { SignalRService } from '../wap/configuration/shared/services/signalR.service';
import { AuthService } from './services/auth.service';
import { Router, NavigationEnd } from '@angular/router';

import { LoginService } from './services/login.service';

@Component({
  selector: 'app-core',
  templateUrl: './core.component.html',
  standalone: false,
})
export class CoreComponent implements OnInit {
  dateInfo: MaintenanceModeNotificationViewModel = null;
  maintenanceDialogOpened: boolean = false;
  routeActive: string;
  allowAccessMaintenanceMode: boolean = true;
  subscription = new Subscription();
  signalRChannel = SignalRChannel.MaintenanceMode;

  constructor(
    private router: Router,
    private loadingService: LoaderService,
    private authService: AuthService,
    private signalR: SignalRService,
    private loginService: LoginService
  ) {
    this.allowAccessMaintenanceMode = this.loginService?.user?.isGlobalAdmin;
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.routeActive = val.url;
      }
    });
  }

  ngOnInit(): void {
    if (!this.allowAccessMaintenanceMode) {
      this.subscribeToSignalR();
      this.firstSetMaintenanceMode();
    }
    this.maintenanceModeNotification();
  }

  private subscribeToSignalR() {
    this.signalR.initializeSignalR(this.signalRChannel);
    this.subscription = this.signalR.getDataStream<any>(this.signalRChannel).subscribe((message) => {
      console.log(message.data);
      if (message.data && !this.dateInfo) {
        localStorage.setItem('maintenanceFrom', `${parseDateByConfiguredLocal(message.data.activeFrom, defaultfilterFullDatetimeFormatGMT)}`);
        localStorage.setItem('maintenanceUntil', `${parseDateByConfiguredLocal(message.data.activeUntil, defaultfilterFullDatetimeFormatGMT)}`);
        this.dateInfo = message.data;
      }
      this.authService.setMaintenanceMode(true);
    });
  }

  private firstSetMaintenanceMode() {
    this.loadingService.startLoading();
    this.authService
      .firstSetMaintenanceMode()
      .pipe(
        take(1),
        finalize(() => this.loadingService.stopLoading())
      )
      .subscribe((data) => {
        if (!!data) {
          this.authService.setMaintenanceMode(data);
        }
      });
  }

  private maintenanceModeNotification() {
    this.loadingService.startLoading();
    this.authService
      .maintenanceModeNotification()
      .pipe(
        take(1),
        finalize(() => this.loadingService.stopLoading())
      )
      .subscribe((data) => {
        if (data) {
          this.dateInfo = data;
          localStorage.setItem('maintenanceFrom', `${parseDateByConfiguredLocal(data.activeFrom, defaultfilterFullDatetimeFormatGMT)}`);
          localStorage.setItem('maintenanceUntil', `${parseDateByConfiguredLocal(data.activeUntil, defaultfilterFullDatetimeFormatGMT)}`);
          this.maintenanceDialogOpened = true;
        }
      });
  }

  closeMaintenanceDialog() {
    this.maintenanceDialogOpened = false;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
